export const SEARCH_AGAIN_BUTTON = "Search again";
export const RETRY_BUTTON = "Retry";
export const AVAILABILITY_ERROR_TITLE = "Something went wrong";
export const AVAILABILITY_ERROR_SUBTITLE = "Please try again.";
